import scale from "@ecco/ui/tokens/space";

import { getRelativeWidthToVW } from "@ecco/ui/relative-width";

export const styles = {
    container: {
        display: "flex",
        justifyContent: "space-between",
        fontSize: ["mobileBodyTextNormal", "desktopBodyTextNormal"],
        fontWeight: "bold",
    },
    part: {
        lineHeight: "base",
        mb: 4,
        fontSize: ["mobileBodyTextNormal", "desktopBodyTextNormal"],
        fontWeight: "bold",
    },
    tooltipIcon: {
        display: "block",
        cursor: "pointer",
        position: "relative",
        top: "-4px",
    },
    tooltip: (props) => {
        const { offset } = props;
        const mappedValues = offset.map((value) => getRelativeWidthToVW(value));

        return {
            flex: "flex-end",
            display: "flex",
            p: 4,
            mr: [0, 0, 0, 4],
            border: `${scale["0.2"]} solid`,
            width: [...mappedValues, 320],
            maxWidth: "unset",
            ml: [6, 8, 10, 0],
        };
    },
};
